/**
 * NoeyeIcon — sanitized from `assets/newSvg/noeye.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function NoeyeIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M2.5,9 C2.5,8.17157 3.17157,7.5 4,7.5 C4.68898,7.5 5.26828,7.96407 5.44478,8.59579 C7.39172,15.0976 16.6031,15.0993 18.5538,8.60092 C18.7286,7.96656 19.3092,7.5 20,7.5 C20.8284,7.5 21.5,8.17157 21.5,9 C21.5,9.15661 21.4758,9.30851 21.4307,9.45166 C21.0603,10.6908 20.5038,11.7702 19.8082,12.6868 L20.7678,13.6464 C21.3536,14.2322 21.3536,15.182 20.7678,15.7677 C20.1821,16.3535 19.2323,16.3535 18.6465,15.7677 L17.6358,14.757 C17.1072,15.1193 16.5474,15.4241 15.9665,15.6715 L16.2094,16.5777 C16.4238,17.3779 15.9489,18.2004 15.1487,18.4148 C14.3485,18.6292 13.526,18.1543 13.3116,17.3542 L13.0609,16.4187 C12.356,16.4917 11.644,16.4917 10.9391,16.4187 L10.6884,17.3542 C10.474,18.1543 9.65149,18.6292 8.85129,18.4148 C8.05109,18.2004 7.57622,17.3779 7.79063,16.5777 L8.03347,15.6714 C7.45272,15.4241 6.89298,15.1194 6.3644,14.7571 L5.35372,15.7677 C4.76794,16.3535 3.81819,16.3535 3.2324,15.7677 C2.64662,15.182 2.64662,14.2322 3.2324,13.6464 L4.19194,12.6869 C3.4975,11.7718 2.94165,10.6944 2.57129,9.45781 C2.52487,9.31287 2.5,9.15886 2.5,9 Z"
        fill={color}
      />
    </Svg>
  );
}

export default NoeyeIcon;
